import { create } from "zustand";

export interface FlyingWishlistItem {
  id: string;
  image?: string;
  from: { x: number; y: number; size: number };
}

interface WishlistUiState {
  wishlistAnchor: HTMLElement | null;
  flyingItems: FlyingWishlistItem[];
  setWishlistAnchor: (el: HTMLElement | null) => void;
  playFlyToWishlist: (args: {
    source: HTMLElement | DOMRect | null;
    image?: string;
  }) => void;
  _removeFlyingItem: (id: string) => void;
}

export const FLY_ANIMATION_MS = 650;

export const useWishlistUiStore = create<WishlistUiState>((set, get) => ({
  wishlistAnchor: null,
  flyingItems: [],

  setWishlistAnchor: (el) => set({ wishlistAnchor: el }),

  playFlyToWishlist: ({ source, image }) => {
    const rect =
      source instanceof HTMLElement
        ? source.getBoundingClientRect()
        : (source as DOMRect | null);
    if (!rect) return;

    const size = Math.min(rect.width, rect.height, 96);
    const item: FlyingWishlistItem = {
      id: `wfly-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      image,
      from: {
        x: rect.left + rect.width / 2 - size / 2,
        y: rect.top + rect.height / 2 - size / 2,
        size,
      },
    };
    set((s) => ({ flyingItems: [...s.flyingItems, item] }));
    window.setTimeout(() => get()._removeFlyingItem(item.id), FLY_ANIMATION_MS + 50);
  },

  _removeFlyingItem: (id) =>
    set((s) => ({ flyingItems: s.flyingItems.filter((i) => i.id !== id) })),
}));
